import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "admin-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = {
  key: 0,
  class: "loading"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_7 = {
  key: 1,
  class: "items-grid"
}
const _hoisted_8 = ["onDragstart", "onDragover", "onDrop"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = {
  key: 1,
  class: "item-thumb item-placeholder"
}
const _hoisted_11 = { class: "item-info" }
const _hoisted_12 = { class: "item-name" }
const _hoisted_13 = {
  key: 0,
  class: "photo-count"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "item-actions" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_21 = {
  key: 1,
  class: "items-grid"
}
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = {
  key: 1,
  class: "item-thumb item-placeholder"
}
const _hoisted_24 = { class: "item-info" }
const _hoisted_25 = { class: "item-name" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "item-actions" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "modal modal-wide" }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = {
  ref: "editorContainer",
  class: "quill-editor"
}
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = {
  key: 0,
  class: "images-preview"
}
const _hoisted_37 = ["onDragstart", "onDragover", "onDrop"]
const _hoisted_38 = ["src"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "position-badge" }
const _hoisted_41 = {
  key: 0,
  class: "form-error"
}
const _hoisted_42 = { class: "modal-actions" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "modal modal-small" }
const _hoisted_45 = { class: "modal-actions" }
const _hoisted_46 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdminLayout = _resolveComponent("AdminLayout")!

  return (_openBlock(), _createBlock(_component_AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[13] || (_cache[13] = _createElementVNode("h1", null, "Продукция", -1)),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreateModal && _ctx.openCreateModal(...args)))
          }, "+ Добавить")
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["tab", { active: _ctx.activeTab === 'published' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'published'))
          }, " Опубликованные (" + _toDisplayString(_ctx.published.length) + ") ", 3),
          _createElementVNode("button", {
            class: _normalizeClass(["tab", { active: _ctx.activeTab === 'hidden' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'hidden'))
          }, " Спрятанные (" + _toDisplayString(_ctx.hidden.length) + ") ", 3)
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Загрузка..."))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.activeTab === 'published')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_ctx.published.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Нет опубликованной продукции"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.published, (item, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.id,
                              class: _normalizeClass(["item-card", { dragging: _ctx.dragIdx === idx, 'drag-over': _ctx.dragOverIdx === idx }]),
                              draggable: "true",
                              onDragstart: ($event: any) => (_ctx.onDragStart(idx)),
                              onDragover: _withModifiers(($event: any) => (_ctx.onDragOver(idx)), ["prevent"]),
                              onDrop: ($event: any) => (_ctx.onDrop(idx)),
                              onDragend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDragEnd && _ctx.onDragEnd(...args)))
                            }, [
                              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "drag-handle" }, "⠿", -1)),
                              (item.photo_urls && item.photo_urls.length > 0)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: item.photo_urls[0],
                                    alt: item.name,
                                    class: "item-thumb"
                                  }, null, 8, _hoisted_9))
                                : (_openBlock(), _createElementBlock("div", _hoisted_10, "Нет фото")),
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("span", _hoisted_12, _toDisplayString(item.name), 1),
                                (item.photo_urls)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.photo_urls.length) + " фото", 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("p", {
                                  class: "item-desc-preview",
                                  innerHTML: _ctx.truncate(item.description)
                                }, null, 8, _hoisted_14),
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("button", {
                                    class: "btn btn-small btn-warning",
                                    onClick: ($event: any) => (_ctx.toggleDisplay(item))
                                  }, "Спрятать", 8, _hoisted_16),
                                  _createElementVNode("button", {
                                    class: "btn btn-small btn-outline",
                                    onClick: ($event: any) => (_ctx.openEditModal(item))
                                  }, "Редактировать", 8, _hoisted_17),
                                  _createElementVNode("button", {
                                    class: "btn btn-small btn-danger",
                                    onClick: ($event: any) => (_ctx.openDeleteConfirm(item))
                                  }, "Удалить", 8, _hoisted_18)
                                ])
                              ])
                            ], 42, _hoisted_8))
                          }), 128))
                        ]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.activeTab === 'hidden')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    (_ctx.hidden.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Нет спрятанной продукции"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hidden, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.id,
                              class: "item-card"
                            }, [
                              (item.photo_urls && item.photo_urls.length > 0)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: item.photo_urls[0],
                                    alt: item.name,
                                    class: "item-thumb"
                                  }, null, 8, _hoisted_22))
                                : (_openBlock(), _createElementBlock("div", _hoisted_23, "Нет фото")),
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("span", _hoisted_25, _toDisplayString(item.name), 1),
                                _createElementVNode("p", {
                                  class: "item-desc-preview",
                                  innerHTML: _ctx.truncate(item.description)
                                }, null, 8, _hoisted_26),
                                _createElementVNode("div", _hoisted_27, [
                                  _createElementVNode("button", {
                                    class: "btn btn-small btn-success",
                                    onClick: ($event: any) => (_ctx.toggleDisplay(item))
                                  }, "Показать", 8, _hoisted_28),
                                  _createElementVNode("button", {
                                    class: "btn btn-small btn-outline",
                                    onClick: ($event: any) => (_ctx.openEditModal(item))
                                  }, "Редактировать", 8, _hoisted_29),
                                  _createElementVNode("button", {
                                    class: "btn btn-small btn-danger",
                                    onClick: ($event: any) => (_ctx.openDeleteConfirm(item))
                                  }, "Удалить", 8, _hoisted_30)
                                ])
                              ])
                            ]))
                          }), 128))
                        ]))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      (_ctx.showModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-overlay",
            onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.editingItem ? "Редактировать продукт" : "Новый продукт"), 1),
              _createElementVNode("form", {
                onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSave && _ctx.handleSave(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_32, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", null, "Название", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formName) = $event)),
                    type: "text",
                    placeholder: "Название продукта"
                  }, null, 512), [
                    [_vModelText, _ctx.formName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", null, "Описание", -1)),
                  _createElementVNode("div", _hoisted_34, null, 512)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", null, "Фото", -1)),
                  _createElementVNode("input", {
                    type: "file",
                    accept: "image/*",
                    multiple: "",
                    onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onFilesChange && _ctx.onFilesChange(...args)))
                  }, null, 32),
                  (_ctx.formImages.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formImages, (img, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: img.key,
                            class: _normalizeClass(["preview-item", { dragging: _ctx.imgDragIdx === idx, 'drag-over': _ctx.imgDragOverIdx === idx }]),
                            draggable: "true",
                            onDragstart: ($event: any) => (_ctx.onImgDragStart(idx)),
                            onDragover: _withModifiers(($event: any) => (_ctx.onImgDragOver(idx)), ["prevent"]),
                            onDrop: ($event: any) => (_ctx.onImgDrop(idx)),
                            onDragend: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onImgDragEnd && _ctx.onImgDragEnd(...args)))
                          }, [
                            _createElementVNode("img", {
                              src: img.url,
                              alt: "Preview"
                            }, null, 8, _hoisted_38),
                            _createElementVNode("button", {
                              type: "button",
                              class: "remove-btn",
                              onClick: ($event: any) => (_ctx.removeImage(idx))
                            }, "×", 8, _hoisted_39),
                            _createElementVNode("span", _hoisted_40, _toDisplayString(idx + 1), 1)
                          ], 42, _hoisted_37))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.formError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.formError), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, "Отмена"),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary",
                    disabled: _ctx.saving
                  }, _toDisplayString(_ctx.saving ? "Сохранение..." : "Сохранить"), 9, _hoisted_43)
                ])
              ], 32)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showDeleteConfirm)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "modal-overlay",
            onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeDeleteConfirm && _ctx.closeDeleteConfirm(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_44, [
              _cache[18] || (_cache[18] = _createElementVNode("h2", null, "Удалить продукт?", -1)),
              _createElementVNode("p", null, "Вы уверены, что хотите удалить «" + _toDisplayString(_ctx.deletingItem?.name) + "»?", 1),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("button", {
                  class: "btn btn-outline",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteConfirm && _ctx.closeDeleteConfirm(...args)))
                }, "Нет"),
                _createElementVNode("button", {
                  class: "btn btn-danger",
                  disabled: _ctx.deleting,
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleDelete && _ctx.handleDelete(...args)))
                }, _toDisplayString(_ctx.deleting ? "Удаление..." : "Да, удалить"), 9, _hoisted_46)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}